import React from 'react';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Colours from '@shared/ui/atoms/Colours';
import { binStyle, EMPTY_BIN, HeatBin, NO_CAPACITY_BIN, OVER_CAPACITY_BIN, RAMP_BINS } from "./heatScale";

interface Props {
  // What a zero means here: nobody in for a floor, not used for desks and rooms
  emptyLabel: string;
  showOverCapacity: boolean;
  showNoCapacity: boolean;
}

export function HeatMapLegend({emptyLabel, showOverCapacity, showNoCapacity}: Props) {
  const {t} = useTranslation();
  const entries: { bin: HeatBin, label: string }[] = [
    {bin: EMPTY_BIN, label: t(emptyLabel)},
    ...RAMP_BINS.map(bin => ({bin, label: bin.label})),
    ...(showOverCapacity ? [{bin: OVER_CAPACITY_BIN, label: t('reports-page.office-usage.heat-map.legend-over')}] : []),
    ...(showNoCapacity ? [{bin: NO_CAPACITY_BIN, label: t('reports-page.office-usage.heat-map.legend-no-capacity')}] : []),
  ];

  return (
    <Legend>
      {entries.map(({bin, label}) => (
        <LegendItem key={bin.key}>
          <Swatch style={binStyle(bin)} />
          {label}
        </LegendItem>
      ))}
    </Legend>
  );
}

const Legend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  list-style: none;
  padding: 0;
  margin: 12px 0;
`

const LegendItem = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: "soleil", sans-serif;
  font-size: 13px;
  color: ${Colours.darkGrey};
`

const Swatch = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 4px;
`
